import React from 'react';
import { MapPin, Phone, Mail, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-serif font-bold mb-4">Connect With Us</h3>
            <div className="space-y-3">
              <div className="flex items-center">
                <MapPin className="w-5 h-5 mr-2 text-red-500" />
                <p>1088 Adeola Odeku, Victoria Island, Lagos</p>
              </div>
              <div className="flex items-center">
                <Phone className="w-5 h-5 mr-2 text-red-500" />
                <p>+234 903 800 0420</p>
              </div>
              {/*
                The Mail icon and email text have been removed as per your comment.
                Uncomment if needed.
              */}
              {/* <div className="flex items-center">
                <Mail className="w-5 h-5 mr-2 text-red-500" />
                <p>contact@restaurant.com</p>
              </div> */}
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-serif font-bold mb-4">Our Hours</h3>
            <div className="space-y-2">
              <p>24 Hours Daily</p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-serif font-bold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              {/* Instagram icon wrapped in a link */}
              <a 
                href="https://www.instagram.com/thegrillshack_ng/" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Instagram className="w-6 h-6 cursor-pointer hover:text-red-500 transition-colors" />
              </a>
              
              {/* Snapchat icon wrapped in a link */}
              <a 
                href="https://www.snapchat.com/add/thegrillshackng" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <img
                  src="https://www.freepnglogos.com/uploads/snapchat-logo-png/snapchat-logo-transparent-png-3.png"
                  alt="Snapchat"
                  className="w-6 h-6 cursor-pointer hover:opacity-80 transition-opacity"
                />
              </a>

              {/* WhatsApp icon remains unchanged */}
              <img
                src="https://static-00.iconduck.com/assets.00/whatsapp-icon-2038x2048-5zk5gj1j.png"
                alt="WhatsApp"
                className="w-6 h-6 cursor-pointer hover:opacity-80 transition-opacity"
              />
            </div>
          
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
